import { render } from "./wConfirmDialog.vue?vue&type=template&id=131359b7"
import script from "./wConfirmDialog.vue?vue&type=script&lang=js"
export * from "./wConfirmDialog.vue?vue&type=script&lang=js"

import "./wConfirmDialog.vue?vue&type=style&index=0&id=131359b7&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__